/*
  Multiplie le prix affiché dans le bouton d'ajout par la quantité choisie.

  Ne fait rien si le bundle est présent : bundle-pack-presets.js pilote déjà ce même
  nœud [data-price-display] et deux scripts qui s'y disputent produisent un prix
  dépendant de l'ordre de chargement.

  Aucune référence n'est mémorisée : le changement de variante fait re-rendre la
  section côté serveur et remplace le bouton. Tout est relu à chaque synchronisation.
*/
(function () {
  'use strict';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || 'fr';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function sync() {
    if (document.querySelector('.bundle-pack-card')) return;

    var button = document.querySelector('.product-form__submit');
    if (!button) return;

    var priceEl = button.querySelector('[data-price-display]');
    var input = document.querySelector('.quantity__input');
    if (!priceEl || !input) return;

    var unit = parseInt(button.dataset.productPrice, 10);
    if (isNaN(unit)) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    var next = formatMoney(unit * qty);
    // N'écrire que si la valeur change : l'observateur ci-dessous surveille le
    // sous-arbre, une écriture inconditionnelle le rappellerait en boucle.
    if (priceEl.textContent.trim() !== next) priceEl.textContent = next;
  }

  ['input', 'change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) sync();
    });
  });

  // Le changement de variante remplace le bouton (et son prix unitaire) : on resynchronise.
  function observe() {
    var host = document.querySelector('product-info') || document.querySelector('.product-form');
    if (!host || !window.MutationObserver) return;
    new MutationObserver(sync).observe(host, { childList: true, subtree: true });
  }

  function start() {
    sync();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
